export const inspectionReport = {
  inspectionInfo: {
    vendorId: 12345,
    inspectedBy: 'epyx Inspector',
    supplierName: 'epyx',
    inspectionDate: '2021-09-14T12:22:00Z',
    orderNo: '747871',
    telNo: '',
    postalAddress: 'epyx Limited CV7 7LL',
    vehicleMake: 'AUDI',
    vehicleModel: 'Q7 TDI QUATTRO S LINE',
    vehicleDerivative: 'TDI QUATTRO S LINE',
    regNo: 'REG123',
    vehicleBodyColour: 'BLUE',
    vehicleTransmission: 'AUTOMATIC',
    vehicleFuelType: 'DIESEL',
    vehicleEngineSize: '1998',
    vehicleDoors: 5,
    vehicleOdometer: '77667',
    vehicleOdometerType: 'miles',
    condition: 'Average',
    masterKey: 'Yes       ',
    spareKeys: '1 Spare Key',
    radioCode: '',
    ignitionCode: '',
    keyCode: '',
    notes: 'Sat Nav not present',
    vehicleType: 'C',
    vehicleDamageTotal: 433.8,
    roadTax: 'Not In Vehicle',
    roadTaxExpiry: null,
    handbook: 'Not In Vehicle',
    motExpiry: null,
    serviceBook: 'Not In Vehicle',
    serviceHistory: '',
    serviceDate: null,
    serviceOdometer: 0,
    serviceLocation: '',
    tyreNotes: '',
    showFaultAction: false,
    showFaultCost: false,
    showSignatures: false,
    driverSignatureBlobId: null,
    inspectorSignatureBlobId: null,
  },
  faultInfo: [
    {
      faultLocationDescription: 'Alloy Wheel NSR',
      faultDescription: 'Scuffed',
      actionDescription: 'Repair & Paint Alloy Wheel',
      cost: null,
      imageCount: 1,
      notes: null,
      vehicleFaultId: 16216173,
      image:
        'https://cdn.uk.staging.group-mobility-trader.de/images/cas/21f575664896b787767f9b366f241547/79e823f4ae8fdf69fd7c186600463d81.jpg',
    },
    {
      faultLocationDescription: 'Bonnet',
      faultDescription: 'Chips',
      actionDescription: 'Touch & Polish',
      cost: null,
      imageCount: 1,
      notes: null,
      vehicleFaultId: 16216170,
      image:
        'https://cdn.uk.staging.group-mobility-trader.de/images/cas/6e55cdd7c244db2eaf7bd8b1c2bf0e80/50716d100f042fa5a25f3ceaf0fb8815.jpg',
    },
  ],
  tyreInfo: [],
  tyreDetailInfo: [
    {
      tyrePosition: 'N/S Front',
      innerTreadDepth: 3.32,
      middleTreadDepth: 3.04,
      outerTreadDepth: 3.05,
      manufacturerName: 'Michelin',
      wheelType: '',
    },
    {
      tyrePosition: 'O/S Front',
      innerTreadDepth: 6.26,
      middleTreadDepth: 6.76,
      outerTreadDepth: 6.15,
      manufacturerName: 'Avon',
      wheelType: '',
    },
    {
      tyrePosition: 'N/S Rear',
      innerTreadDepth: 5.67,
      middleTreadDepth: 4.98,
      outerTreadDepth: 5.38,
      manufacturerName: 'Michelin',
      wheelType: '',
    },
    {
      tyrePosition: 'O/S Rear',
      innerTreadDepth: 5.0,
      middleTreadDepth: 5.0,
      outerTreadDepth: 5.0,
      manufacturerName: 'Michelin',
      wheelType: '',
    },
    {
      tyrePosition: 'Spare',
      innerTreadDepth: null,
      middleTreadDepth: null,
      outerTreadDepth: null,
      manufacturerName: '',
      wheelType: '',
    },
  ],
  imageInfos: {
    '16216174': [' https://exampleUrl.net/1'],
    '16216173': [' https://exampleUrl.net/1'],
  },
  vendorLogo: ' https://exampleUrl.net/1',
  reference: null,
};
